import { createContext, useContext } from 'react';

export const DefaultFavoriteStrategiesConfig = {
  favoriteStrategies: [] as string[],
};

export const DefaultFavoriteStrategiesMethods = {
  setFavoriteStrategies: (favoriteStrategies: string[]) => {},
};

export const DefaultFavoriteStrategiesContext = {
  ...DefaultFavoriteStrategiesConfig,
  ...DefaultFavoriteStrategiesMethods,
};

export type FavoriteStrategiesConfig = typeof DefaultFavoriteStrategiesConfig;
export type FavoriteStrategiesContextProps = typeof DefaultFavoriteStrategiesContext;

export const DefaultFavoritesStrategiesConfig: FavoriteStrategiesContextProps = {
  favoriteStrategies: [],
  setFavoriteStrategies: () => {},
};

export const FavoriteStrategiesContext = createContext<FavoriteStrategiesContextProps>(
  DefaultFavoriteStrategiesContext
);
FavoriteStrategiesContext.displayName = 'FavoriteStrategiesContext';

export function useFavoriteStrategies() {
  const context = useContext(FavoriteStrategiesContext);
  if (context === undefined) {
    throw new Error('Missing FavoriteStrategiesContext.Provider further up in the tree. Did you forget to add it?');
  }
  return context;
}
